var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVipStarIcon = function SvgVipStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#vip-star-icon_svg__a)",
    fill: "#12B76A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.154 11.77H15v.461h1.154a.231.231 0 0 0 0-.461Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.966 9.247a.692.692 0 0 0-.45-.447l-6.808-2.145L12.564.843a.693.693 0 0 0-1.128 0L7.292 6.655.484 8.8a.692.692 0 0 0-.348 1.072l4.247 5.738-.064 7.137a.692.692 0 0 0 .912.663L12 21.144l6.769 2.266a.692.692 0 0 0 .912-.663l-.064-7.137 4.247-5.738a.692.692 0 0 0 .102-.625ZM10.34 11.319l-1.384 3.693a.692.692 0 0 1-1.297 0l-1.384-3.693a.692.692 0 0 1 1.296-.486l.737 1.964.736-1.964a.692.692 0 0 1 1.296.486Zm2.352 3.45a.692.692 0 1 1-1.384 0v-3.693a.692.692 0 0 1 1.384 0v3.692Zm3.462-1.154H15v1.153a.692.692 0 1 1-1.385 0v-3.692c0-.382.31-.692.693-.692h1.846c.89 0 1.615.725 1.615 1.615 0 .891-.724 1.616-1.615 1.616Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "vip-star-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgVipStarIcon;